<template>
    
    <div class="add-to-cart">        

        <a class="title__wrapper" :href="linkRemplacement"
            v-if="!article.isActive && article.refRemplacement!=null && remplacementAvailable">
            <span>Remplacé</span>
        </a>

        <span v-if="(!article.isActive || !variation.isPurchasable) && (article.refRemplacement==null || !remplacementAvailable)">Indisponible</span>
        
        <div class="add-to-cart__qty" v-if="article.isActive && variation.isPurchasable">
            <input class="input-text qty text"
                type="number"
                min="0" 
                v-model="quantity" />
        </div>
        <div class="add-to-cart__btn" v-if="!processing && article.isActive && variation.isPurchasable">
            <button class="woocommerce-button button add_to_cart_button"
                type="button"
                title="Ajouter au panier"
                :disabled="disabled"
                v-on:click="addToCart()">
                <span class="fa fa-shopping-cart"></span>
            </button>
        </div>
        <div class="add-to-cart__spinner" v-if="processing">
            <Spinner></Spinner>
        </div>

    </div>

</template>

<script>
import Vue from 'vue';

import api from '@/api/wp/cart'
import Spinner from '@/components/spinner/Spinner.vue'

export const ADD_TO_CART_EVENT = 'addtocart'

export const CartBus = new Vue();

export default {

    data: function() {
        return {
            processing: false,
            quantity: 1
        }
    },

    props: {
        article: Object,
        variation: Object
    },

    computed: {

        css: function () {
            return ''
        },

        disabled: function () {
            return this.processing
        },

        remplacementAvailable: function () {
            return this.article.slugRemplacement
        },

        linkRemplacement: function () {
            return ( this.article.slugRemplacement ) ? this.$config.SITE_URL + '/product/' + this.article.slugRemplacement : null
        }

    },

    methods: {        

        addToCart: function() {

            this.processing = true

            api.postArticle(this.article.id, this.quantity, this.variation.id)          
                .then( () => {
                    this.$notify.success(this.article.title + " ajouté au panier")
                    this.$emit(ADD_TO_CART_EVENT, {})
                    CartBus.$emit(ADD_TO_CART_EVENT, {})
                })
                .catch( () => this.$notify.error("Impossible d'ajouter " + this.article.title + " au panier") )
                .finally( () => this.processing = false )
        }
    },

    components: {
        Spinner
    }
}
</script>

<style scoped>

.add-to-cart {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.add-to-cart .add-to-cart__qty {
    margin-right: 0.5rem;
    max-width: 4.8rem;
    min-width: 4rem;
}

.add-to-cart .add-to-cart__qty input[type="number"],
.add-to-cart .add-to-cart__qty .input-text {
    width: 100%;
}

.add-to-cart .add-to-cart__btn button,
.add-to-cart .add-to-cart__btn .button {
    margin: 0 !important;
    min-width: 3.5rem;
    width: 3.5rem;
}

.add-to-cart .add-to-cart__spinner {
    position: relative;
    overflow: hidden;
    height: 3rem;
    width: 3.5rem;
}

.add-to-cart .add-to-cart__spinner .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(.26);
}

</style>